export enum WarehouseCode {
  BLACK_CAT = "TCAT",
  REN_TRAP = "RENTRAP",
  DEPART = "DEPART",
  OEM = "OEM",
}

export const warehouseData = [
  { label: "黑貓", code: WarehouseCode.BLACK_CAT },
  { label: "藍田", code: WarehouseCode.REN_TRAP },
  { label: "百貨倉", code: WarehouseCode.DEPART },
  { label: "委外加工倉", code: WarehouseCode.OEM },
];

// options
export const warehouseCodeOptions = warehouseData.map(({ label, code }) => ({ label, value: code }));

export const warehouseCodeOptionsUrmartDisabled = warehouseData.map(({ label, code }) => ({
  label,
  value: code,
  disabled: code === WarehouseCode.DEPART || code === WarehouseCode.OEM,
}));

/*
 * 後端暫時還沒有倉庫跟通路鉤稽的端點和表格，黑貓專屬通路先暫時寫在前端
 */
export const tcatRetailersOptions = ["B2C-Line 禮物", "B2C-好市多"];

// 查詢函數
export const getWarehouseCode = (warehouseCode: string) => {
  return warehouseData.find((item) => item.code === warehouseCode) || null;
};

export const getWarehouseLabel = (warehouseCode: string) => {
  return warehouseData.find((item) => item.code === warehouseCode)?.label || "";
};
